module.exports = __webpack_public_path__ + "static/OneDotExt.43521041.woff";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/OneDotExt.woff
// module id = 754
// module chunks = 114276838955818